import { define, generateTestIdObject } from '../../utils';

const PAGE_NAME = 'qset-list';

const ELEMENTS = define({
  // The header trigger shares its "Generate QSet" label with the modal's own
  // title and submit button, so role + name cannot disambiguate it while the
  // modal is open. Applied at the call site, not inside `GenerateQSetButton`:
  // that container is also the Draft list's empty-state CTA, and tagging it
  // would put this id on two buttons at once.
  GENERATE_QSET_BUTTON: ['generate-qset', 'button'],
  // Opens the QSet Review creation modal with this course already applied, so
  // the modal renders the course as a read-only field instead of the
  // autocomplete. Applied at the call site for the same reason as above:
  // `QSetReviewTaskCreationButton` is also the Task Management list's
  // "Create Task" trigger.
  CREATE_REVIEW_TASK_BUTTON: ['create-review-task', 'button'],
});

export const QSET_LIST_DATA_TEST_ID = generateTestIdObject(PAGE_NAME, ELEMENTS);
